<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Avaliações</h3>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex">
            <div class="col-6">
              <h6 class="m-0">Avaliações disponíveis</h6>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <rating-table :ratings="rating.list" />
            </div>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import RatingTable from '../components/RatingTable.vue';

export default {
  name: 'user-rating-list',
  components: {
    Pagination,
    RatingTable,
  },
  data() {
    return {
    };
  },
  computed: {
    rating() {
      const { ratingList } = this.$store.state.rating;
      if (ratingList && ratingList.list.length) {
        return ratingList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getRatingList',
    ]),
    getList() {
      this.getRatingList();
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
